import { BaseModel, attr, hasMany } from "../../lib/itn-ui-kit/data";

export default class FollowUpsHistoryModel extends BaseModel {
  @attr("string") formName;
  @attr("string") formId;
  @attr("json") formHeader;
  @hasMany("follow-ups-form-section") sections;
}
